import ExcelIcon from '@/components/icons/ExcelIcon';
import GoogleDocsIcon from '@/components/icons/GoogleDocsIcon';
import GoogleSheetsIcon from '@/components/icons/GoogleSheetsIcon';
import WordIcon from '@/components/icons/WordIcon';
import { cn } from '@/lib/utils';

/**
 * The apps a table can be copied from, as their own marks.
 *
 * They replace the list of names the instruction used to carry ("no Excel, no
 * Google Sheets, no Docs ou no Word"): the row answers "de onde dá para colar?"
 * before the sentence above it is finished, and that sentence gets a line
 * shorter. Labelled rather than hidden — with the names gone from the prose,
 * the marks are the only place the answer lives.
 *
 * Sized by height: the Microsoft marks are square, the two Google ones are
 * portrait pages, so a common width would squash them against each other.
 *
 * The heading that introduces the row ("Funciona com") belongs to the caller —
 * on its own the row read as decoration adrift in the dialog.
 */
export function PasteSourceLogos({ className }: { className?: string }) {
    return (
        <div className={cn('flex items-center justify-center gap-5', className)}>
            <span role="img" aria-label="Microsoft Excel">
                <ExcelIcon className="h-6 w-auto" />
            </span>
            <span role="img" aria-label="Google Sheets">
                <GoogleSheetsIcon className="h-6 w-auto" />
            </span>
            <span role="img" aria-label="Microsoft Word">
                <WordIcon className="h-6 w-auto" />
            </span>
            <span role="img" aria-label="Google Docs">
                <GoogleDocsIcon className="h-6 w-auto" />
            </span>
        </div>
    );
}
